import {
  Icon,
  IconColor,
  IconName,
  IconSize,
  textStyleUtils
} from '@focaldata/cin-ui-components'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import React from 'react'
import useStyles from './EmptyState.style'

interface Props extends React.HTMLAttributes<HTMLElement> {
  title?: string
  subtitle?: string
  iconName: IconName
  hasElevation?: boolean
  button?: React.ReactNode
}

const EmptyState: React.FC<Props> = (props: Props) => {
  const { style, title, subtitle, iconName, hasElevation, button }: Props =
    props
  const { classes } = useStyles()
  const { classes: textClasses, cx: classNames } =
    textStyleUtils.useTextStyles()

  return (
    <Paper
      className={classes.emptyPaperStyle}
      style={style}
      elevation={hasElevation ? 1 : 0}
    >
      <Grid
        container
        className={classes.emptyOuterDiv}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid
          container
          item
          direction="column"
          alignItems="center"
          className={classes.emptyInnerDiv}
          spacing={2}
        >
          <Grid item xs={12}>
            <Icon
              name={iconName}
              size={IconSize.Large}
              iconColor={IconColor.Background}
            />
          </Grid>
          <Grid container item xs={12} direction="column" alignItems="center">
            <Grid item xs={12}>
              <p
                className={classNames(
                  textClasses.default,
                  textClasses.highlightBackground,
                  textClasses.sizeL,
                  textClasses.weightRegular
                )}
              >
                {title}
              </p>
            </Grid>
            <Grid item xs={12}>
              <p
                className={classNames(
                  textClasses.default,
                  textClasses.highlightBackground,
                  textClasses.sizeM,
                  textClasses.weightRegular
                )}
              >
                {subtitle}
              </p>
            </Grid>
          </Grid>
          {button && (
            <Grid item xs={12}>
              {button}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Paper>
  )
}

export default EmptyState
